<img class="logo" [src]="asset('assets/images/ibk-logo.svg')" alt="Interbank logo" />

<h2 class="title f-regular">Abre tu Cuenta Negocios 100% digital</h2>

<ul class="check-list">
  <li class="check-list__item">
    <ibk-icon class="bullet">check</ibk-icon>
    <span class="content"> Abre tu Cuenta Negocios <b class="f-bold">¡Sin trámites ni papeleos!</b> </span>
  </li>
  <li class="check-list__item">
    <ibk-icon class="bullet">check</ibk-icon>
    <span class="content"> Accede a la Banca por Internet Empresas <b class="f-bold">sin costo</b>. </span>
  </li>
</ul>

<ba-btn-trigger class="trigger" (trigger)="trigger.emit()"> </ba-btn-trigger>

<button (click)="trigger.emit()" class="trigger-rsp ibk-btn ibk-btn--primary trigger__btn ba-btn">Comencemos</button>
